import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Users({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'24px'} height={'20px'} viewBox={'0 0 24 20'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(0.000000, -2.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M18,21 C18,21.5522847 17.5522847,22 17,22 C16.4477153,22 16,21.5522847 16,21 L16,19 C16,17.3431458 14.6568542,16 13,16 L5,16 C3.34314575,16 2,17.3431458 2,19 L2,21 C2,21.5522847 1.55228475,22 1,22 C0.44771525,22 0,21.5522847 0,21 L0,19 C2.77555756e-16,16.2385763 2.23857625,14 5,14 L13,14 C15.7614237,14 18,16.2385763 18,19 L18,21 Z M9,12 C6.23857625,12 4,9.76142375 4,7 C4,4.23857625 6.23857625,2 9,2 C11.7614237,2 14,4.23857625 14,7 C14,9.76142375 11.7614237,12 9,12 Z M9,10 C10.6568542,10 12,8.65685425 12,7 C12,5.34314575 10.6568542,4 9,4 C7.34314575,4 6,5.34314575 6,7 C6,8.65685425 7.34314575,10 9,10 Z M24,21 C24,21.5522847 23.5522847,22 23,22 C22.4477153,22 22,21.5522847 22,21 L22.0000003,19.0007459 C21.9989805,17.6335842 21.0737494,16.440036 19.7500003,16.0982459 C19.2152528,15.9601749 18.8936831,15.4147477 19.0317541,14.8800003 C19.1698251,14.3452528 19.7152523,14.0236831 20.2499997,14.1617541 C22.4562482,14.7314043 23.9983001,16.7206513 24,19 L24,21 Z M15.7519608,4.09875 C15.216935,3.96176174 14.8942617,3.41698667 15.03125,2.88196081 C15.1682383,2.34693496 15.7130133,2.02426174 16.2480392,2.16125 C18.4604327,2.72771223 20.0078433,4.72123893 20.0078433,7.005 C20.0078433,9.28876107 18.4604327,11.2822878 16.2480392,11.84875 C15.7130133,11.9857383 15.1682383,11.663065 15.03125,11.1280392 C14.8942617,10.5930133 15.216935,10.0482383 15.7519608,9.91125 C17.0793969,9.57137266 18.0078433,8.37525664 18.0078433,7.005 C18.0078433,5.63474336 17.0793969,4.43862734 15.7519608,4.09875 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Users.propTypes = {
  className: PropTypes.string,
}
